import { jsx } from "react/jsx-runtime";
import HeadsetIcon from "@mui/icons-material/Headset";
import { validateTidalLicense } from "../../base/index.js";
function Headset(props) {
  return /* @__PURE__ */ jsx(
    HeadsetIcon,
    {
      "data-testid": "Headset",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Headset",
      "data-tidal-icon-meta": "chat,customerService"
    }
  );
}
Headset.tidalIconMeta = {
  categories: "chat,customerService",
  name: "Headset"
};
validateTidalLicense();
export {
  Headset
};
//# sourceMappingURL=Headset.js.map
